import { render, staticRenderFns } from "./QuestionViewAdminSuper.vue?vue&type=template&id=19624096&scoped=true&lang=pug&"
import script from "./QuestionViewAdminSuper.vue?vue&type=script&lang=js&"
export * from "./QuestionViewAdminSuper.vue?vue&type=script&lang=js&"
import style0 from "./QuestionViewAdminSuper.vue?vue&type=style&index=0&id=19624096&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19624096",
  null
  
)

export default component.exports